import { Button } from '@/components/ui/button';
import { AlertCircle } from 'lucide-react';

export default function CustomError({
  onRetry,
  error,
}: {
  onRetry: () => void;
  error: Error;
}) {
  return (
    <div className="flex h-full items-center justify-center">
      <div className="flex flex-col items-center gap-4 p-4">
        <AlertCircle className="w-12 h-12 text-red-500 " />
        <div className="text-3xl font-bold text-gray-800">Error</div>
        <div className="text-center text-gray-600 max-w-md">
          {error.message}
        </div>
        <Button
          onClick={onRetry}
          className="mt-2 px-6 hover:bg-gray-700 transition-all hover:scale-105
            shadow-sm"
        >
          Retry
        </Button>
      </div>
    </div>
  );
}
